import PageTitle from '~atoms/PageTitle';

type MaterialsProps = React.HTMLAttributes<HTMLDivElement> & {
  materialsSlot: JSX.Element;
};

const Materials = ({ materialsSlot }: MaterialsProps) => (
  <div>
    <PageTitle>Material</PageTitle>
    {materialsSlot}
  </div>
);

export default Materials;
